import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface PrivacyPolicyPageProps {}

@inject(deps) @observer
export class PrivacyPolicyPage extends Component<PrivacyPolicyPageProps> {
  render() {
    return (
      <PageGenericPrismic
        model={this.props.model.page.privacyPolicy}
      />
    )
  }
}